module.exports = vuedraggable;


//////////////////
// WEBPACK FOOTER
// external "vuedraggable"
// module id = 570
// module chunks = 30